<pp-three-ds-content
  toastView
  [message]="message()"
  (markAsRead)="markAsRead.emit()" />

<button
  class="close-btn"
  type="button"
  puButton
  uiType="quaternary"
  size="m"
  [onlyIcon]="true"
  (click)="close(true)">
  <pu-icon iconName="close" size="16" />
</button>
